
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reclamo",
      function () {
        return require("private-next-pages/reclamo.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reclamo"])
      });
    }
  